<template>
  <div class="visitor-visa">
    <h1>旅游探亲签证Visitor Visa</h1>
    <div class="subtitle">访问签证</div>
    <p>是为来加拿大进行旅游探亲的外国人发放的签证，有效期最长为十年。</p>
  </div>
</template>

<script>
export default {
  name: 'VisitorVisaView'
}
</script>

<style scoped lang="less">
.visitor-visa {
    width: 80%;
    height: 100%;
    max-width: 1200px;
    margin: 50px auto;
    // background-color: antiquewhite;
  h1 {
    font-size: 32px;
    color: #333;
    margin-bottom: 10px;
  }

  .subtitle {
    font-size: 18px;
    color: #666;
    margin-bottom: 30px;
  }
}
</style>